import React from "react";
import { Search } from "lucide-react";
import { useCompany } from "../context/CompanyContext";

export default function ReviewFilters({ sortBy, setSortBy, activeTag, setActiveTag, query, setQuery, activeRating, setActiveRating }) {
  const { company } = useCompany();
  const tags = company.tags;
  const total = Object.values(company.ratingBreakdown).reduce((a, b) => a + b, 0);
  return (
    <div className="bg-white rounded-md border border-gray-200 p-4 mb-4">
      <div className="text-sm font-semibold text-gray-800 mb-2">Show reviews that mention</div>
      <div className="flex gap-2 mb-3">
        <div className="flex-1 min-w-0 flex items-center bg-[#f5f7f8] rounded-md px-3">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search keywords"
            className="flex-1 min-w-0 bg-transparent py-2 text-sm outline-none"
          />
        </div>
        <button className="bg-[#007a8a] hover:bg-[#005f6b] transition-colors text-white px-3 rounded-md flex items-center justify-center gap-1 text-sm font-medium shrink-0" aria-label="search">
          <Search size={16}/>
        </button>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        {tags.map((t) => (
          <button
            key={t}
            onClick={() => setActiveTag(activeTag === t ? null : t)}
            className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${
              activeTag === t
                ? "bg-[#007a8a] text-white border-[#007a8a]"
                : "bg-[#f5f7f8] text-gray-700 border-gray-200 hover:bg-gray-100"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      <div className="border-t border-gray-100 pt-4">
        <div className="text-sm font-semibold text-gray-800 mb-2">Filter review</div>
        <div className="space-y-1.5">
          {[5, 4, 3, 2, 1].map((star) => {
            const count = company.ratingBreakdown[star];
            const pct = (count / total) * 100;
            const active = activeRating === star;
            return (
              <button
                key={star}
                onClick={() => setActiveRating(active ? null : star)}
                className="w-full flex items-center gap-2 group"
              >
                <span className={`text-xs w-3 ${active ? "font-bold text-[#007a8a]" : "text-gray-600"}`}>{star}</span>
                <div className="flex-1 h-3 bg-gray-100 rounded overflow-hidden">
                  <div
                    className={`h-full transition-all ${active ? "bg-[#005f6b]" : "bg-[#007a8a] group-hover:bg-[#005f6b]"}`}
                    style={{ width: `${Math.max(pct, 1)}%` }}
                  />
                </div>
                <span className="text-xs text-gray-600 w-12 text-right">{count.toLocaleString()}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="border-t border-gray-100 mt-4 pt-4">
        <div className="text-sm font-semibold text-gray-800 mb-2">Sort by</div>
        <div className="flex gap-1 bg-[#f5f7f8] rounded-md p-1">
          {["Helpful", "Latest"].map((s) => (
            <button
              key={s}
              onClick={() => setSortBy(s)}
              className={`flex-1 text-sm px-3 py-1.5 rounded transition-colors ${
                sortBy === s ? "bg-white text-[#007a8a] font-semibold shadow-sm" : "text-gray-600 hover:text-gray-800"
              }`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
